<div class="container">
  <app-receipt></app-receipt>
  <app-small-footer></app-small-footer>
</div>
